import type { ColDef } from "ag-grid-community";

/** Floor width used by AppGrid.sizeColumnsToFit when fitting columns to the viewport. */
export const GRID_FIT_MIN_WIDTH = 60;

export const FITTABLE_DEFAULT_COL_DEF: ColDef = {
  sortable: true,
  resizable: true,
  filter: true,
  wrapHeaderText: true,
  autoHeaderHeight: true,
  flex: 1,
  minWidth: 75,
};

/** Default col def for read-only detail grids nested inside expanded rows. */
export const DETAIL_GRID_DEFAULT_COL_DEF: ColDef = {
  sortable: true,
  filter: false,
  resizable: true,
  wrapHeaderText: true,
  autoHeaderHeight: true,
  flex: 1,
  minWidth: 60,
};

export const GRID_SELECTION_COLUMN_DEF: ColDef = {
  width: 44,
  minWidth: 44,
  maxWidth: 44,
  sortable: false,
  resizable: false,
  suppressSizeToFit: true,
  pinned: "left",
};
